import { saveAs } from 'file-saver'
export function downloadArquivoProtegido(doc: any, nomeArquivo: string) {
  const buffer = new Uint8Array(doc.Body.data)
  const blob = new Blob([buffer], { type: doc.ContentType })
  const url = window.URL.createObjectURL(blob)
  window.open(url, '_blank')
  saveAs(blob, nomeArquivo ?? 'Arquivo')
  setTimeout(() => window.URL.revokeObjectURL(url), 100)
}
